/* @fflow */
import { difference } from 'lodash';
import { fetchGraphql } from '../utils/ajax';

export let UPLOAD_TRANSACTIONS_REQUEST = 'gdc/UPLOAD_TRANSACTIONS_REQUEST';
export let UPLOAD_TRANSACTIONS_SUCCESS = 'gdc/UPLOAD_TRANSACTIONS_SUCCESS';
export let UPLOAD_TRANSACTIONS_FAILURE = 'gdc/UPLOAD_TRANSACTIONS_FAILURE';
export let UPLOAD_TRANSACTIONS_MANUAL_REQUEST = 'gdc/UPLOAD_TRANSACTIONS_MANUAL_REQUEST';

function queryTransactions({
  quickSearch, first, offset, sort, order, program, project, id, state, type,
}) {
  return {
    variables: {
      quickSearch,
      first,
      offset,
      projectId: project ? `${program}-${project}` : null,
      id,
      orderByAsc: order === 'asc' ? sort : null,
      orderByDesc: order === 'desc' ? sort : null,
      state,
      type: type || null,
    },
    query:
      `query UploadTransactionsQuery(
        $first: Int
        $offset: Int
        $projectId: [String]
        $orderByAsc: String
        $orderByDesc: String
        $type: String
      ) {
        items: transaction_log(
          project_id: $projectId
          order_by_asc: $orderByAsc
          order_by_desc: $orderByDesc
          first: $first
          offset: $offset
          type: $type,
          closed: false
        ) {
          id
          project_id
          type
          created_datetime
          state
          is_dry_run
          committed_by
          submitter
          closed
        }
      }`
  };
}

export let showOptimisticPendingTransaction = () => ({ type: UPLOAD_TRANSACTIONS_MANUAL_REQUEST });

export let fetchUploadTransactions = (variables) => {
  return (dispatch, getState) => {
    const {isFetching} = getState().uploadTransactions;
    if (!isFetching) {
      dispatch(fetchGraphql([
        UPLOAD_TRANSACTIONS_REQUEST,
        UPLOAD_TRANSACTIONS_SUCCESS,
        UPLOAD_TRANSACTIONS_FAILURE
      ],
        queryTransactions(variables)
      ));
    }
  };
};

export default function reducer(state = {
  isFetching: false,
  otherTransactions: {
    items: [],
  },
  data: {
    items: [],
  },
}, action) {
  switch (action.type) {
  case UPLOAD_TRANSACTIONS_MANUAL_REQUEST:
    return {
      ...state,
      isFetching: false,
      data: { items: [
        {
          state: 'LOADING',
          id: '',
          created_datetime: '1/1/1000',
          committed_by: null,
        },
        ...state.data.items.slice(0, 4),
      ]}
    };
  case UPLOAD_TRANSACTIONS_REQUEST:
    return {
      ...state,
      isFetching: true,
    };
  case UPLOAD_TRANSACTIONS_SUCCESS:
    const uploadTransactions = action.payload.data.items.filter(x => x.type === 'upload').slice(0, 5);
    const otherTransactions = action.payload.data.items.filter(x => x.type !== 'upload');

    const desiredNewState = {
      ...state,
      isFetching: false,
      data: { items: uploadTransactions },
      otherTransactions: { items: otherTransactions },
    };

    if (difference(
      state.data.items.filter(x => x.id).map(x => x.id),
      uploadTransactions.map(x => x.id)
    ).length) {
      return desiredNewState;
    }

    // if no new transactions have been returned since the last poll
    // while manual request is being made, return existing state
    if (state.data.items[1] && uploadTransactions[0] && uploadTransactions[0].id === state.data.items[1].id) {
      return state;
    }

    return desiredNewState;
  case UPLOAD_TRANSACTIONS_FAILURE:
    return {
      ...state,
      isFetching: false
    };
  default:
    return state;
  }
}
